var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.spClass,attrs:{"type":"button"}},[_c('icon',{class:_vm.icon,attrs:{"icon":_vm.icon,"height":_vm.iconHeight,"width":_vm.iconWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }